import { EmptyLayout } from '../constants'

/**
 * @type {import('vue-router').RouteConfig[]}
 */
export default [
  {
    path: '/user',
    component: EmptyLayout,
    redirect: '/user/login',
    meta: { title: '校友登录', hide: true },
    children: [
      {
        path: 'login',
        component: () => import('@/views/user/login.vue'),
        meta: { title: '校友登录', hide: true },
      },
      {
        path: 'register',
        component: () => import('@/views/user/register.vue'),
        meta: { title: '校友注册', hide: true },
      },
    ],
  },
]
